// Enums
export * from "./enums/GPlayerPronoun.js";
export * from "./enums/InternalType.js";
export * from "./enums/RolesPermissionsType.js";
export * from "./enums/SubscriptionType.js";
// Interfaces
export * from "./interfaces/IBaseID.js";
export * from "./interfaces/IGPlayer.js";
export * from "./interfaces/ILogin.js";
export * from "./interfaces/INation.js";
export * from "./interfaces/IPairingMatch.js";
export * from "./interfaces/IPermissions.js";
export * from "./interfaces/IPlayer.js";
export * from "./interfaces/IPod.js";
export * from "./interfaces/ITournament.js";
export * from "./interfaces/ITournamentPairing.js";
export * from "./interfaces/ITournamentsSubscription.js";
export * from "./interfaces/ITournamentStanding.js";
export * from "./interfaces/ITournamentTick.js";
export * from "./interfaces/ITournamentType.js";
export * from "./interfaces/IUser.js";
export const timeLimitExceeded = (tournament_date, tournament_start) => {
    const date = new Date(tournament_date), time = new Date(tournament_start);
    date.setHours(time.getHours());
    date.setMinutes(time.getMinutes());
    date.setSeconds(0, 0);
    const dateMinus15 = new Date(date.getTime());
    dateMinus15.setMinutes(dateMinus15.getMinutes() - 15);
    return new Date().getTime() > dateMinus15.getTime();
};